import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { connect } from 'react-redux';

import { VpCheckbox } from '@vp-ui/inputs';
import { useMediaTableContext } from '@src/hooks';
import { getIsSelectingSsembleMedia } from '@src/redux/modules/ssemble';
import PropTypes from 'prop-types';

const headCells = [
  {
    id: 'campaign',
    label: 'Campaign',
  },
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'tags',
    label: 'Tags',
  },
  {
    id: 'media',
    label: 'Media',
  },
  {
    id: 'date',
    label: 'Submission Date',
  },
];

export const VpMediaTableHead = ({ isSelectingSsembleMedia }) => {
  const { onPageCheck, getIsPageAllSelected, getIsPagePartialSelected } = useMediaTableContext();
  const onClick = () => {
    onPageCheck();
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        <TableCell padding="checkbox">
          {!isSelectingSsembleMedia && (
            <VpCheckbox
              indeterminate={getIsPagePartialSelected()}
              checked={getIsPageAllSelected()}
              onClick={onClick}
            />
          )}
        </TableCell>
        {headCells.map((cell) => (
          <TableCell key={cell.id}>{cell.label}</TableCell>
        ))}
        <TableCell padding="checkbox"></TableCell>
      </TableRow>
    </TableHead>
  );
};

VpMediaTableHead.propTypes = {
  isSelectingSsembleMedia: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isSelectingSsembleMedia: getIsSelectingSsembleMedia(state),
});

export default connect(mapStateToProps)(VpMediaTableHead);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTableHead.jsx